import { render } from "./BpCoordBar.vue?vue&type=template&id=72512a81&scoped=true"
import script from "./BpCoordBar.vue?vue&type=script&lang=js"
export * from "./BpCoordBar.vue?vue&type=script&lang=js"

import "./BpCoordBar.vue?vue&type=style&index=0&id=72512a81&scoped=true&lang=css"

import exportComponent from "/browser/CARTaGENE_vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72512a81"]])

export default __exports__